import { DEFAULT_ACCOUNT_PREFERENCES } from "@shared/types/account-preferences";
// ---------------------------------------------------------------------------
// Initial State
// ---------------------------------------------------------------------------
export const initialUIState = {
    activeBlockId: undefined,
    isFocusMode: false,
    isLassoActive: false,
    isMultiselectMode: false,
    selectionContainer: undefined,
    streamFadeOpacity: 1,
    omnibarQuery: "",
    omnibarMode: "add",
    openStackId: undefined,
    pendingNewStackId: undefined,
    isOmnibarFocused: false,
};
export const initialDebugState = {
    showWipBorder: false,
};
/**
 * "No drag in flight" — every field at its no-op default. Used as the
 * initial value AND as the value passed to `setDragEnd()` for cleanup,
 * so the slice never sits in a half-cleared state between drags.
 */
export const INITIAL_DRAG_STATE = {
    activeBlockId: undefined,
    activeSourceScopeKey: undefined,
    foreignPointerScopeKey: undefined,
    stackOnDropParentId: undefined,
    liveTransform: undefined,
    multi: undefined,
};
export const INITIAL_STACK_UNFURL_STATE = {
    openStackId: undefined,
    phase: "closed",
    envelopes: undefined,
    showUnfurledItems: false,
};
export const initialAppState = {
    cards: new Map(),
    selection: new Set(),
    collectionSelection: new Set(),
    stackSelection: new Set(),
    lassoSelection: new Set(),
    selectionAnchor: undefined,
    ui: initialUIState,
    debug: initialDebugState,
    preferences: DEFAULT_ACCOUNT_PREFERENCES,
    drag: INITIAL_DRAG_STATE,
    stackUnfurl: INITIAL_STACK_UNFURL_STATE,
};
// ---------------------------------------------------------------------------
// Card State Helpers
// ---------------------------------------------------------------------------
export const initialCardUIState = {
    zIndex: 0,
};
